import { useQuery } from '@tanstack/react-query'
import { fetchUsersList } from '@/features/users/api'

export function useUsersListQuery() {
  return useQuery({
    queryKey: ['users'],
    queryFn: fetchUsersList
  })
}
